export const visit = (vm, at) => {
at({ "hu": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} / {{totalBytes}}" }, "fileSizeLimit": "A f\xE1jl legfeljebb ekkora lehet: {{size}}", "screenCapture": "K\xE9perny\u0151felv\xE9tel" } } });
};